export var LoginSessionType;
(function (LoginSessionType) {
    LoginSessionType["PrivateKey"] = "private_key";
    LoginSessionType["PublicKey"] = "public_key";
    LoginSessionType["Nip7"] = "nip7";
    LoginSessionType["Nip46"] = "nip46";
})(LoginSessionType || (LoginSessionType = {}));
